<template lang="html">
  <div class="card-timeline-post">
    <div class="card-top">
      <div class="headshot">
        <img src="http://www.placehold.it/50x50" class="rounded-circle" alt="">
      </div>
      <div class="info">
        <p class="name">Dave Johnson</p>
        <p class="post-date">Yesterday for <a href="#">Work on Proove</a> at <a href="#">The Hermitage</a></p>
      </div>
      <div class="options text-right">
        <div class="dropdown dropleft">
          <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a class="dropdown-item" href="#">Edit Post</a>
            <a class="dropdown-item" href="#">Delete</a>
          </div>
        </div>
      </div>
    </div>
    <div class="card-main">
      <div class="card-text">
        <p>Some quick example text to build on the card title and make up the bulk of the card's content.</p>
      </div>
      <div class="card-content">
        <img class="img-responsive" src="http://www.placehold.it/400px600" alt="Card image cap">
      </div>
    </div>
    <div class="card-actions">
      <div class="card-buttons">
        <button class="btn btn-md btn-outline-primary" type="button" name="button"><i class="fa fa-thumbs-up"></i> Like <span>6</span></button>
        <button class="btn btn-md btn-outline-primary" type="button" name="button"><i class="fa fa-comment"></i> Comment <span>7</span></button>
      </div>
      <div class="card-comments">
        <ul class="comments-list">

          <!-- Main Comment -->
          <li class="main-comment">
            <div class="the-comment">
              <div class="headshot">
                <img src="http://www.placehold.it/40x40" class="rounded-circle" alt="">
              </div>
              <div class="comment-text">
                <p class="the-text">
                  <a class="commentor" href="#">Dave Johnson</a> This is a long comment that will span two lines eventually if I write enough.
                  <div class="like-bubble-wrapper">
                    <div class="like-bubble">
                      <i class="fa fa-thumbs-up"></i>
                      <span>13</span>
                    </div>
                  </div>
                </p>
                <ul class="comment-text-actions">
                  <li><a href="#">Like</a></li>
                  <li><a href="#">Reply</a></li>
                  <li>16h</li>
                </ul>
              </div>
              <div class="comment-options">
                <div class="dropdown dropleft">
                  <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" href="#">Edit Comment</a>
                    <a class="dropdown-item" href="#">Delete</a>
                  </div>
                </div>
              </div>
            </div>
            <ul class="nested-comments">

              <!-- Nested Comment -->
              <li class="nested-comment">
                <div class="the-comment">
                  <div class="headshot">
                    <img src="http://www.placehold.it/35x35" class="rounded-circle" alt="">
                  </div>
                  <div class="comment-text">
                    <p class="the-text">
                      <a class="commentor" href="#">Ryan Hanson</a> Yep!
                      <div class="like-bubble-wrapper">
                        <div class="like-bubble">
                          <i class="fa fa-thumbs-up"></i>
                          <span>13</span>
                        </div>
                      </div>
                    </p>
                    <ul class="comment-text-actions">
                      <li><a href="#">Like</a></li>
                      <li><a href="#">Reply</a></li>
                      <li>16h</li>
                    </ul>
                  </div>
                  <div class="comment-options">
                    <div class="dropdown dropleft">
                      <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" href="#">Edit Comment</a>
                        <a class="dropdown-item" href="#">Delete</a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- Nested Comment -->
              <li class="nested-comment">
                <div class="the-comment">
                  <div class="headshot">
                    <img src="http://www.placehold.it/35x35" class="rounded-circle" alt="">
                  </div>
                  <div class="comment-text">
                    <div class="comment-text">
                      <p class="the-text"><a class="commentor" href="#">Casey Elizabeth</a> This is a nested comment</p>
                      <ul class="comment-text-actions">
                        <li><a href="#">Like</a></li>
                        <li><a href="#">Reply</a></li>
                        <li>16h</li>
                      </ul>
                    </div>
                  </div>
                  <div class="comment-options">
                    <div class="dropdown dropleft">
                      <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" href="#">Edit Comment</a>
                        <a class="dropdown-item" href="#">Delete</a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <!-- Nested Comment -->
              <li class="nested-comment">
                <div class="the-comment">
                  <div class="headshot">
                    <img src="http://www.placehold.it/35x35" class="rounded-circle" alt="">
                  </div>
                  <div class="comment-text">
                    <p class="the-text">
                      <a class="commentor" href="#">Ryan Hanson</a> This is a nested comment that goes for a couple of lines. I don't really know what to say here but figure I can just type some stuff and hopefully it'll hit three lines. I could have just copy and pasted...
                      <div class="like-bubble-wrapper">
                        <div class="like-bubble">
                          <i class="fa fa-thumbs-up"></i>
                          <span>13</span>
                        </div>
                      </div>
                    </p>
                    <ul class="comment-text-actions">
                      <li><a href="#">Like</a></li>
                      <li><a href="#">Reply</a></li>
                      <li>16h</li>
                    </ul>
                  </div>
                  <div class="comment-options">
                    <div class="dropdown dropleft">
                      <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" href="#">Edit Comment</a>
                        <a class="dropdown-item" href="#">Delete</a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

            </ul>
          </li>

          <!-- Main Comment -->
          <li class="main-comment">
            <div class="the-comment">
              <div class="headshot">
                <img src="http://www.placehold.it/40x40" class="rounded-circle" alt="">
              </div>
              <div class="comment-text">
                <div class="comment-text">
                  <p class="the-text"><a class="commentor" href="#">Beth Johnson</a> This is a comment</p>
                  <ul class="comment-text-actions">
                    <li><a href="#">Like</a></li>
                    <li><a href="#">Reply</a></li>
                    <li>16h</li>
                  </ul>
                </div>
              </div>
              <div class="comment-options">
                <div class="dropdown dropleft">
                  <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" href="#">Edit Comment</a>
                    <a class="dropdown-item" href="#">Delete</a>
                  </div>
                </div>
              </div>
            </div>
            <ul class="nested-comments">
              <!-- No nested comments -->
            </ul>
          </li>

          <!-- Main Comment -->
          <li class="main-comment">
            <div class="the-comment">
              <div class="headshot">
                <img src="http://www.placehold.it/40x40" class="rounded-circle" alt="">
              </div>
              <div class="comment-text">
                <div class="comment-text">
                  <p class="the-text"><a class="commentor" href="#">Molly Johnson</a> This is a comment</p>
                  <ul class="comment-text-actions">
                    <li><a href="#">Like</a></li>
                    <li><a href="#">Reply</a></li>
                    <li>16h</li>
                  </ul>
                </div>
              </div>
              <div class="comment-options">
                <div class="dropdown dropleft">
                  <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                  <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                    <a class="dropdown-item" href="#">Edit Comment</a>
                    <a class="dropdown-item" href="#">Delete</a>
                  </div>
                </div>
              </div>
            </div>
            <ul class="nested-comments">

              <!-- Nested Comment -->
              <li class="nested-comment">
                <div class="the-comment">
                  <div class="headshot">
                    <img src="http://www.placehold.it/35x35" class="rounded-circle" alt="">
                  </div>
                  <div class="comment-text">
                    <div class="comment-text">
                      <p class="the-text"><a class="commentor" href="#">Dave Johnson</a> This is a nested comment</p>
                      <ul class="comment-text-actions">
                        <li><a href="#">Like</a></li>
                        <li><a href="#">Reply</a></li>
                        <li>16h</li>
                      </ul>
                    </div>
                  </div>
                  <div class="comment-options">
                    <div class="dropdown dropleft">
                      <a class="btn btn-sm" href="#" role="button" id="dropdownMenuLink" data-offset="25,0" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-ellipsis-v"></i></a>

                      <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
                        <a class="dropdown-item" href="#">Edit Comment</a>
                        <a class="dropdown-item" href="#">Delete</a>
                      </div>
                    </div>
                  </div>
                </div>
              </li>

            </ul>
          </li>

        </ul>
      </div>
      <div class="card-comment-box">
        <div class="headshot">
          <img src="http://www.placehold.it/40x40" class="rounded-circle" alt="">
        </div>
        <div class="comment-textarea">
          <form>
            <div class="form-group">
              <textarea-autosize rows="1" id="comment-box" class="form-control" placeholder="Press enter to comment" v-model="mainComment" :min-height="37" :max-height="350"></textarea-autosize>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import VueTextareaAutosize from 'vue-textarea-autosize'

export default {
  name: 'Post',
  data() {
    return {
      mainComment: null,
    }
  },
  created() {
    Vue.use(VueTextareaAutosize)
  }
}

</script>

<style scoped>

.card-timeline-post {
  border-radius: 5px;
  -webkit-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  -moz-box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  box-shadow: 0px 0px 28px -7px rgba(0,0,0,0.17);
  border: 1px dotted #c9c9c9;
  margin-bottom: 20px;
}
.card-timeline-post p {
  padding: 0;
  margin: 0;
}
.card-top {
  display: flex;
  padding: 10px;
}
.card-top .headshot {
  flex: 1;
}
.card-top .info {
  flex: 5;
  padding-top: 5px;
}
.card-top .info .name {
  font-weight: bold;
  font-size: 14px;
}
.card-top .info .post-date {
  font-size: 12px;
}
.card-top .options {
  flex: 1;
}
.card-main {

}
.card-main .card-text {
  padding: 0 15px 10px 15px;
  font-size: 14px;
}
.card-main .card-content {

}
.card-main .card-content img {
  width: 100%;
  height: auto;
}
.card-actions {

}
.card-actions .card-buttons {
  padding: 15px 8px;
}
.card-actions .card-buttons button {
  margin: 0 8px;
  border: none;
  font-size: 15px;
}
.card-actions .card-buttons button:hover {
  background: white;
  color: #0056b3;
}
.card-actions .card-buttons button i {
  margin-right: 5px;
}
.card-actions .card-buttons button span {
  background: #007bff;
  padding: 4px 9px;
  color: #fff;
  border-radius: 18px;
  font-size: 12px;
  font-weight: bold;
  margin-left: 5px;
}

/* Timeline Post Comments */
.card-actions .card-comments {
  border-top: 1px dotted #c9c9c9;
}
.comments-list {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.comments-list .main-comment {
  padding: 10px 10px 0 10px;
}
.comments-list .main-comment .the-comment {
  display: flex;
  padding-bottom: 10px;
}
.comments-list .main-comment .the-comment .headshot {
  flex: 1;
}
.comments-list .main-comment .the-comment .comment-text {
  flex: 5;
  display: inline-block;
  position: relative;
}
.comments-list .main-comment .the-comment .comment-text .the-text {
  display: inline-block;
  background-color: #efefef;
  padding: 5px 10px;
  border-radius: 5px;
  font-size: 13px;
}
.comments-list .main-comment .the-comment .comment-text .the-text .commentor {
  font-weight: bold;
  text-align: left !important;
}
.comments-list .main-comment .the-comment .comment-text .like-bubble-wrapper {
  display: inline;
  text-align: right;
  position: absolute;
  min-width: 50px;
  margin-left: -25px;
  margin-top: -20px;
}
.comments-list .main-comment .the-comment .comment-text .like-bubble {
  display: inline-block;
  background: #fff;
  -webkit-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .2);
  -moz-box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .2);
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .2);
  border-radius: 18px;
  padding: 4px 3px 3px 3px;
  font-size: 10px;
}
.comments-list .main-comment .the-comment .comment-text .like-bubble i {
  background: #007bff;
  color: #fff;
  padding: 4px;
  border-radius: 50%;
}

.comments-list .main-comment .the-comment .comment-text .comment-text-actions {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.comments-list .main-comment .the-comment .comment-text .comment-text-actions li {
  display: inline;
  margin-right: 7px;
  font-size: 11px;
}
.comments-list .main-comment .the-comment .comment-options {
  flex: 1;
  text-align: right;
}
.comments-list .main-comment .the-comment .comment-options .dropdown {
  display: none;
}
.comments-list .main-comment .the-comment:hover .comment-options .dropdown {
  display: inline;
}

/* Timeline Post Nested Comments */
.comments-list .main-comment .nested-comments {
  list-style-type: none;
  margin: 0;
  padding: 0;
}
.comments-list .main-comment .nested-comments .nested-comment {
  margin-left: 30px;
}
.comments-list .main-comment .nested-comments .nested-comment .the-comment {
  display: flex;
}
.comments-list .main-comment .nested-comments .nested-comment .the-comment .headshot {
  flex: 1;
}
.comments-list .main-comment .nested-comments .nested-comment .the-comment .comment-text {
  flex: 6;
}
.comments-list .main-comment .nested-comments .nested-comment .the-comment .comment-text .the-text {
  font-size: 11.5px;
}
.comments-list .main-comment .nested-comments .nested-comment .the-comment .comment-options {
  flex: 1;
  text-align: right;
}
.card-comment-box {
  display: flex;
  padding: 15px 15px 0 15px;
  border-top: 1px dotted #c9c9c9;
}
.card-comment-box .headshot {
  flex: 1;
}
.card-comment-box .comment-textarea {
  flex: 6;
}
.card-comment-box .comment-textarea form {
  width:100%;
}
.card-comment-box .comment-textarea .input-group {

}
.card-comment-box .comment-textarea textarea {
  border-radius: 18px;
  font-size: 13px;
  padding: 8px 15px;
  resize: none;
  min-height: 37px;
  height: auto;
  outline: none;
}
</style>



// WEBPACK FOOTER //
// src/components/utility/Post.vue